var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"color":_vm.cor,"dark":!_vm.textoEscuro,"small":"","label":""}},[_vm._v(_vm._s(_vm.rotulo))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }